import React, { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useProjectAppLoading } from '../../../providers/ProjectAppViewLoadingProvider';
import { useAgent } from '../../../contexts/AgentContext';
import { generateColorVariants } from '../sidebar/threadUtils';
import './project-app-loading-indicator.scss';

interface ProjectAppLoadingIndicatorProps {
  appId: string;
}

const ProjectAppLoadingIndicator: React.FC<ProjectAppLoadingIndicatorProps> = ({
  appId,
}) => {
  const { isLoading, isConsidering } = useProjectAppLoading();
  const [searchParams] = useSearchParams();
  const { getAgentById } = useAgent();

  const agentId = searchParams.get('agent_id');
  const agent = useMemo(
    () => (agentId ? getAgentById(agentId) : undefined),
    [agentId, getAgentById],
  );

  const colours = useMemo(
    () =>
      agent?.predominant_colour
        ? generateColorVariants(agent.predominant_colour)
        : null,
    [agent?.predominant_colour],
  );

  const active = isLoading(appId);
  const considering = isConsidering(appId);
  const nickname = agent?.nickname || agent?.name;
  const imageUrl = agent?.image_url;

  const statusText = considering
    ? `${nickname} is reviewing the page`
    : `${nickname} is updating this page`;

  return (
    <div
      className={`project-app-loading-indicator${active ? ' visible' : ''}`}
      style={
        {
          '--app-loading-lighter': colours?.lighter,
          '--app-loading-base': colours?.base,
          '--app-loading-darker': colours?.darker,
        } as React.CSSProperties
      }
    >
      {imageUrl && (
        <div className='avatar-wrapper'>
          <img src={imageUrl} alt={nickname || 'Agent'} />
        </div>
      )}
      <span>{statusText}</span>
    </div>
  );
};

export default ProjectAppLoadingIndicator;
